export default {"src":"/_next/static/media/ashlok_logo.4b803d4f.svg","height":111,"width":197,"blurWidth":0,"blurHeight":0};